import applyPaginationQueryParams from '@forwardflow/helpers/utils/applyPaginationQueryParams'
import {
   ISubscribeToPackage,
   ISubscriptionPackage,
   IOrganizationSubscription,
   PaginatedResponse,
   PaginationQueryParams,
   ResponseSuccess,
   IBillingHistory,
   ICoupon,
} from '@forwardflow/types'
import { apiGet, apiPost } from '../Axios/configs'

export default class SubscriptionService {
   // Get pricing list
   static async getSubscriptionLists(queryParams: PaginationQueryParams) {
      const response = await apiGet<ResponseSuccess<ISubscriptionPackage>>({
         apiPath: `/subscriptions?${applyPaginationQueryParams(queryParams)}`,
      })
      return response.data
   }

   // Get user subscription
   static async getUserSubscription() {
      const data = await apiGet<ResponseSuccess<IOrganizationSubscription>>({
         apiPath: `/subscriptions/my`,
      })
      return data.data
   }

   // Subscribe to price package
   static async subscribeToPackage(_packageId: string, card: any) {
      const data = await apiPost<ResponseSuccess<ISubscribeToPackage>>({
         apiPath: `/subscriptions/subscribe-to-package`,
         data: {
            paymentInfo: {
               cardId: `${card.id}`,
               nameOnCard: `${card.name}`,
               country: `${card.country}`,
               addressLineOne: `${card.address}`,
               city: `${card.city}`,
               postalCode: `${card.postalCode}`,
            },
            couponCode: `${card.promoCode || ''}`,
         },
      })
      return data.data
   }

   // toggle subscription
   static async toggleSubscription(actionType: string) {
      const data = await apiPost<ResponseSuccess<IOrganizationSubscription>>({
         apiPath: `/subscriptions/update-subscription-status`,
         data: {
            status: actionType,
         },
      })
      return data.data
   }

   // Get billing history

   static async getSubscriptionBillingHistory(
      queryParams: PaginationQueryParams
   ) {
      const response = await apiGet<PaginatedResponse<IBillingHistory>>({
         apiPath: `/subscriptions/recent-invoices?${applyPaginationQueryParams(
            queryParams
         )}`,
      })
      return response
   }

   // Verify coupon code
   static async verifyCouponCode(code: string) {
      const response = await apiGet<ResponseSuccess<ICoupon>>({
         apiPath: `/coupons/${code}`,
         includeXOrg: false,
      })
      return response.data
   }

   // Add seats to subscription
   static async addSeats(orgId: string, seats: number) {
      const data = await apiPost<ResponseSuccess<any>>({
         apiPath: `/subscriptions/add-seats`,
         data: {
            orgId,
            seats,
         },
         includeXOrg: false,
      })
      return data.data
   }

   // Remove seats from subscription
   static async removeSeats(orgId: string, seats: number) {
      const data = await apiPost<ResponseSuccess<any>>({
         apiPath: `/subscriptions/remove-seats`,
         data: {
            orgId,
            seats,
         },
         includeXOrg: false,
      })
      return data.data
   }
}
